export default {
  cities: 'cities',
  retailers: 'retailers',
  retailersPublic: 'retailers-public',
  counties: 'counties',
  supervisoryDistricts: 'supervisory-districts',
  visits: 'visits',
  ingestVisits: 'ingest-visits',
  filterLocation: 'mapping/list/calcpoly',
  agencies: 'agencies',
  users: 'users',
  savedDirections: 'saved-directions',
  retailerCorporation: 'retailers_corporations',
  assessments: 'assessments',
  assignments: 'assignments',
  educations: 'educations',
  campaigns: 'campaigns',
  revisits: 'retailers/revisits_needed',
  youth: 'youth',
  auditLogs: 'audit-logs',
  auditCSV: 'audit-logs-csv',
  revisitsCSV: 'retailer_revisits_csv',
  campaignCSV: 'campaigns_csv',
  assignmentsCSV: 'assignments_csv',
  roles: 'roles',
  secGeogs: 'sec-geogs',
  accounts: 'accounts',
  enforcementCSV: 'enforcements_csv',
  educationCSV: 'educations_csv',
  assessmentCSV: 'assessments_csv',
  mapping: 'mapping/validation/boundary/',
  venues: 'venues',
  venuesCSV: 'venues_csv',
  usersCSV: 'users_csv',
  calcPoly: 'mapping/list/calcpoly/',
  areaReport: 'reports/area-summary-report',
  retailLanscape: 'retailers/retailers-landscape-report',
  postEnforcementReport: 'visits/enforcement-report/',
  postAssessmentEducationReport: 'visits/assessment-education-report/',
  newReports: 'visits/reports-new/',
  enforcementReport: 'reports/enforcement-overview-report',
  educationReport: 'reports/education-overview-report',
  azReport: 'reports/az',
  maReport: 'reports/ma',
  mySecGeogs: 'my-sec-geogs',
  youthAppeal: 'reports/youthappeal',
  disparateBurden: 'reports/disparateburden',
  enforcementOverview: 'reports/enforcementoverview',
  posLandscape: 'reports/poslandscape',
  retailerReduction: 'reports/retailerreduction',
  enforcementViolations: 'enforcement_violations',
  educationViolations: 'education_violations',
  userNotifications: 'user-notifications/',
  courtsList: 'courts',
  directionRouter: 'mapping/directions/directions',
  vroomOptimization: 'mapping/directions/optimizedroute',
  assessmentsForm: 'assessments/available-forms',
  educationForms: 'educations/available-forms',
  enforcementForms: 'enforcements/available-forms',
  enforcementAgencies: 'enforcements/available-agencies',
  atccYears: 'retailers/atcc_years',
  synarYears: 'retailers/synar_years',
  appDashboardAccounts: 'app-dashboard/accounts/',
  appDashboardVisitActivity: 'app-dashboard/visit-activity/',
  appDashboardViolationByTime: 'app-dashboard/violation-by-time/',
  appDashboardViolationsByOfficer: 'app-dashboard/violations-by-officer/',
  appDashboardViolationsByYouth: 'app-dashboard/violations-by-youth/',
  appDashboardViolationsByRetailer: 'app-dashboard/violations-by-retailer/',
  appDashboardWorkload: 'app-dashboard/workload/',
  appDashboardRetailerVisitMap: 'app-dashboard/retailer-visit-map/',
  appDashboardDrivingDirectionsUsage: 'app-dashboard/driving-directions-usage/',
  appDashboardAccountSummary: 'app-dashboard/account-summary/',
  appDashboardActiveUsersGraph: 'app-dashboard/active-users-graph/',
  appDashboardUserActivityGraph: 'app-dashboard/user-activity-graph/',
  appDashboardUserActivityProfile: 'app-dashboard/user-activity-profile/',
  appDashboardUserActivityOperationTypes: 'app-dashboard/user-activity-profile/operation-types/',
  appDashboardServerResponseTime: 'app-dashboard/server-response-time/',
  appDashboardThroughput: 'app-dashboard/throughput/',
  appDashboardImpact: 'app-dashboard/impact/',
  appDashboardUserActivityLogs: 'app-dashboard/user-activity-logs/',
  appDashboardUserActivityLogAuditLogs: (id) => `app-dashboard/user-activity-logs/${id}/audit-logs/`,
  appDashboardModularityMatrix: 'app-dashboard/modularity-matrix/',
  appDashboardFilterMatrix: 'app-dashboard/filter-matrix/',
  appDashboardOtherPermissionsMatrix: 'app-dashboard/other-permissions-matrix/',
  appDashboardGeogsMatrix: 'app-dashboard/geogs-matrix/',
  appDashboardGeneralPermissionsMatrix: 'app-dashboard/general-permissions-matrix/',
  appDashboardStaffUsers: 'app-dashboard/staff/users/',
  appDashboardStaffAccountsMatrix: 'app-dashboard/staff/accounts-matrix/',
  appDashboardStaffGeographies: 'app-dashboard/staff/geographies/',
  appDashboardStaffPermissions: 'app-dashboard/staff/permissions/',
  // Users Management (Tenants Management sub-group) — copies of the Staffs
  // pages; they reuse the staff endpoints until the pages diverge.
  appDashboardTenantUsers: 'app-dashboard/staff/users/',
  appDashboardTenantUsersGeographies: 'app-dashboard/staff/geographies/',
  appDashboardUserAccounts: 'app-dashboard/staff/user-accounts/',
  appDashboardWorkloadProfileExport: 'app-dashboard/workload-profile-export/',
  appDashboardSlowQueriesExport: 'app-dashboard/slow-queries-export/',
  appDashboardGovRampSnapshot: 'app-dashboard/govramp-snapshot/',
  appDashboardGovRampEvidence: 'app-dashboard/govramp-evidence/',
  appDashboardGovRampEvidenceRecord: (id) => `app-dashboard/govramp-evidence/${id}/`,
  appDashboardGovRampEvidenceDocument: (id) => `app-dashboard/govramp-evidence/documents/${id}/`,
  appDashboardGovRampEvidenceDownload: (id) => `app-dashboard/govramp-evidence/documents/${id}/download/`,
  appDashboardTenantsLogicSynarFlag: 'app-dashboard/tenants-logic/synar-flag/',
  appDashboardTenantsLogicSynarZipcodesToIds: 'app-dashboard/tenants-logic/synar-zipcodes-to-ids/',
  appDashboardTenantsLogicSynarFlaggedRetailers: 'app-dashboard/tenants-logic/synar-flagged-retailers/',
  appDashboardTenantsLogicSynarDelete: 'app-dashboard/tenants-logic/synar-delete/',
  appDashboardControlNumbersValidate: 'app-dashboard/control-numbers/validate/',
  appDashboardControlNumbersApply: 'app-dashboard/control-numbers/apply/',
  appDashboardMergerTuningAccounts: 'app-dashboard/merger-tuning/accounts/',
  appDashboardMergerTuningResolvedPairs: 'app-dashboard/merger-tuning/resolved-pairs/',
  appDashboardMergerTuningBackfill: 'app-dashboard/merger-tuning/backfill/',
  appDashboardMergerTuningPairsInRange: 'app-dashboard/merger-tuning/pairs-in-range/',
  businessRules: 'business-rules/',
  businessRulesDomains: 'business-rules/domains/',
  requirementsTraceability: 'requirements-traceability/',
  requirementsTraceabilityDataset: (slug) => `requirements-traceability/${slug}/`,
  requirementsTraceabilityByRule: 'requirements-traceability/by-rule/',
  presignedUrl: 'uploads/presigned-url',
  citiesMissingGeogs: 'mapping/checks/cities-missing-geogs/',
  appDashboardLostRetailerVisits: 'app-dashboard/lost-retailer-visits/',
  appDashboardGhostSynarAttachments: 'app-dashboard/ghost-synar-attachments/',
};
